(() => {
  if (customElements.get('mervaux-hero-video')) return;

  customElements.define('mervaux-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-hero-video-toggle]');
      if (!this.video || !this.button) return;

      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._screen = window.matchMedia('(max-width: 749px)');
      this._inView = false;
      this._pausedByUser = false;
      this._blocked = false;
      this.video.muted = true;
      this.video.playsInline = true;
      this.button.hidden = false;
      this.updateControl();

      this.video.addEventListener('playing', () => this.updateControl(), options);
      this.video.addEventListener('pause', () => this.updateControl(), options);
      this.video.addEventListener('error', () => {
        this._blocked = true;
        this.updateControl();
      }, options);
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.video.paused) {
          this._pausedByUser = true;
          this.video.pause();
        } else {
          this._pausedByUser = false;
          this._blocked = false;
          this.play();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this._screen.addEventListener('change', () => this.sync(), options);
      this._motion.addEventListener('change', () => this.sync(), options);

      if ('IntersectionObserver' in window || typeof IntersectionObserver !== 'undefined') {
        this._observer = new IntersectionObserver((entries) => {
          this._inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.15 });
        this._observer.observe(this);
      } else {
        this._inView = true;
        this.sync();
      }
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this.video?.pause();
    }

    updateControl() {
      const playing = !this.video.paused && !this.video.ended;
      this.setAttribute('data-playing', playing ? 'true' : 'false');
      this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
    }

    sync() {
      const canAutoplay = this._inView && !document.hidden && this.getClientRects().length > 0
        && !this._motion.matches && !navigator.connection?.saveData && !this._pausedByUser && !this._blocked;
      if (!canAutoplay) {
        this.video.pause();
        return;
      }
      if (this.video.paused) this.play();
    }

    play() {
      this.video.muted = true;
      this.video.playsInline = true;
      const attempt = this.video.play();
      if (attempt?.catch) attempt.catch(() => {
        this._blocked = true;
        this.updateControl();
      });
    }
  });
})();
